// =============================================================================
// Predict UI access — per-user allowlist so we can dogfood the full Predict.fun
// UI in PRODUCTION without exposing it to everyone yet.
//
// `ENABLE_PREDICT` (global env flag) still wins → everyone sees it. Otherwise
// only usernames in NEXT_PUBLIC_PREDICT_ALLOWLIST (comma-separated; defaults to
// `zeroxitadori`) see it. Pure check below; `usePredictEnabled` hook wraps it
// with the logged-in user. UI-visibility only — backend trading has its own gates.
// =============================================================================

import { ENABLE_PREDICT } from "./feature-flags";

const PREDICT_ALLOWLIST = (process.env.NEXT_PUBLIC_PREDICT_ALLOWLIST || "zeroxitadori")
  .split(",")
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

/** Pure: is the Predict UI enabled for this username? (env flag OR allowlist). */
export function isPredictAllowed(username?: string | null): boolean {
  if (ENABLE_PREDICT) return true;
  const u = username?.toLowerCase();
  return !!u && PREDICT_ALLOWLIST.includes(u);
}
